var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-segment-id-input"},[_c('b-form-input',{staticClass:"form-control auto-width inputHeight",attrs:{"value":_vm.value,"type":"number","placeholder":"SegmentId"},on:{"input":_vm.updateSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }